module.exports = __webpack_public_path__ + "img/apply.ae64cb62.png";